import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { boApprehensionsNature, boApprehensionsNatureGroup, boApprehensionsStreet, boApprehensionsNeighborhood, boApprehensionsType, boApprehensionsSubtype }
        = useReportFiltersFetch({fetchBoApprehensionsNature: true, fetchBoApprehensionsNatureGroup: true, fetchBoApprehensionsStreet: true, fetchBoApprehensionsNeighborhood: true,
                                 fetchBoApprehensionsType: true, fetchBoApprehensionsSubtype: true });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        label="Natureza"
                        isMulti={true}
                        wrapValues={true}
                        options={boApprehensionsNature}
                        value={filters.nature}
                        onChange={(value) => setFilters(prev => ({...prev, nature: value}))}
                        id="nature"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label="Grupo de natureza"
                        isMulti={true}
                        wrapValues={true}
                        options={boApprehensionsNatureGroup}
                        value={filters.nature_group}
                        onChange={(value) => setFilters(prev => ({...prev, nature_group: value}))}
                        id="nature_group"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label="Logradouro"
                        isMulti={true}
                        wrapValue={true}
                        options={boApprehensionsStreet}
                        value={filters.street}
                        onChange={(value) => setFilters(prev => ({ ...prev, street: value }))}
                        id="street"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label="Bairro"
                        isMulti={true}
                        wrapValue={true}
                        options={boApprehensionsNeighborhood}
                        value={filters.neighborhood}
                        onChange={(value) => setFilters(prev => ({ ...prev, neighborhood: value }))}
                        id="neighborhood"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label="Tipo"
                        isMulti={true}
                        wrapValue={true}
                        options={boApprehensionsType}
                        value={filters.type}
                        onChange={(value) => setFilters(prev => ({ ...prev, type: value }))}
                        id="type"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label="Subtipo"
                        isMulti={true}
                        wrapValue={true}
                        options={boApprehensionsSubtype}
                        value={filters.subtype}
                        onChange={(value) => setFilters(prev => ({ ...prev, subtype: value }))}
                        id="subtype"
                        classNameWrapper={"w-full"}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;